import React from 'react';

function PlusIcon({ option, rotated = false, errorColor = false, blueBackground = false }) {
  const lineColor = errorColor ? '#E53935' : '#FFFFFF';
  const backgroundColor = blueBackground ? '#017CE0' : '#D7D7D6';

  return (option === 'large'
    ? (
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 40 40" enableBackground="new 0 0 40 40">
        <path fill={backgroundColor} d="M3,0h34c1.7,0,3,1.3,3,3v34c0,1.7-1.3,3-3,3H3c-1.7,0-3-1.3-3-3V3C0,1.3,1.3,0,3,0z" className="background" />
        <path fill="none" stroke={lineColor} strokeWidth="2" strokeLinecap="square" d={rotated ? 'M14.3,14.3l11.3,11.3' : 'M20,12v16'} />
        <path fill="none" stroke={lineColor} strokeWidth="2" strokeLinecap="square" d={rotated ? 'M14.3,25.7l11.3-11.3' : 'M12,20h16'} />
      </svg>
    ) : (
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 20 20" enableBackground="new 0 0 20 20">
        <path fill={backgroundColor} d="M3,0h14c1.7,0,3,1.3,3,3v14c0,1.7-1.3,3-3,3H3c-1.7,0-3-1.3-3-3V3C0,1.3,1.3,0,3,0z" className="background" />
        <path fill="none" stroke={lineColor} strokeWidth="2" strokeLinecap="square" d={rotated ? 'M7.2,7.2l5.7,5.7' : 'M10,6v8'} />
        <path fill="none" stroke={lineColor} strokeWidth="2" strokeLinecap="square" d={rotated ? 'M7.2,12.8l5.7-5.7' : 'M6,10h8'} />
      </svg>
    )
  );
}

export default PlusIcon;



// WEBPACK FOOTER //
// ./src/components/icons/PlusMultIcon.js